import React from "react";
type TTag = {
  tag: string;
};

export const Tag = ({ tag }: TTag) => {
  return (
    <p className="uppercase  text-primary-200 py-1 px-3 rounded-full bg-primary-600 w-fit text-[13px] font-800 tracking-[ 0.65px]">
      {tag}
    </p>
  );
};
